import { render, staticRenderFns } from "./Equipments.vue?vue&type=template&id=0083b8da&scoped=true&"
import script from "./Equipments.vue?vue&type=script&lang=js&"
export * from "./Equipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083b8da",
  null
  
)

export default component.exports